import { RelayLog } from '@/common/api/params/relay'
import {
  ListFollowTableHeaderProps,
  makeRectPropsForTableHeadItem,
  useListScrollFollow
} from '@/common/app/list'
import { SearchConditionBase } from '@/common/util/search'

import TableHeadItem from '@/components/view/atoms/table/TableHeadItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

import RelayLogListRow from '@/components/container/modules/master/relay/table/RelayLogListRow'
import ScrollFollowTable from '@/components/container/utils/list/ScrollFollowTable'

const COLUMNS = ['ID', 'サイトID', 'ファイル名', 'ステータス', '詳細', '日時']

interface TheadProps extends ListFollowTableHeaderProps {
  float?: boolean
}

const Thead = ({ float = false, rowRefs, rowRects }: TheadProps) => {
  const rectProps = (index: number) =>
    makeRectPropsForTableHeadItem(rowRefs, rowRects, index, float)

  return (
    <>
      {COLUMNS.map((col, i) => (
        <TableHeadItem key={col} float={float} {...rectProps(i)}>
          <Text size={12} color={TextColor.SECONDARY} nowrap>
            {col}
          </Text>
        </TableHeadItem>
      ))}
    </>
  )
}

interface Props {
  logs: RelayLog[]
  total: number
  condition: SearchConditionBase
  onUpdatePage: (page: number) => void
}

const RelayLogListTable = ({ logs, total, condition, onUpdatePage }: Props) => {
  const listFollowProps = useListScrollFollow(COLUMNS.length)
  const theadProps: TheadProps = { ...listFollowProps.header }

  return (
    <ScrollFollowTable
      listFollowProps={listFollowProps}
      tableHead={<Thead {...theadProps} />}
      tableFloatHead={<Thead {...theadProps} float />}
      body={
        <>
          {logs.map((log) => (
            <RelayLogListRow key={log.id} log={log} />
          ))}
        </>
      }
      condition={condition}
      onUpdatePage={onUpdatePage}
      total={total}
    />
  )
}

export default RelayLogListTable
